// UserDetails.js
import React from 'react';
import { useParams, useNavigate, NavLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Container, Paper, Typography } from '@material-ui/core';
import {
	useGetUserDetailsQuery,
	useDeleteUserMutation,
	useGetProfileAttachmentsQuery,
} from '../../../store/apiSlice';
import Const from '../../../defs/const';

const useStyles = makeStyles((theme) => ({
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	paper: {
		padding: theme.spacing(2),
	},
	row: {
		margin: theme.spacing(1, 0),
	},
	label: {
		fontWeight: 'bold',
		marginRight: theme.spacing(1),
	},
	buttons: {
		display: 'flex',
		gap: theme.spacing(2),
		marginBottom: theme.spacing(2),
	},
}));

export function UserDetails() {
	const classes = useStyles();
	const navigate = useNavigate();
	const { id } = useParams();

	// 1. Fetch user details from RTK Query
	const {
		data: user,
		isLoading,
		isError,
	} = useGetUserDetailsQuery({ id: +id });
	// 2. Delete user mutation (optional)
	const [deleteUser] = useDeleteUserMutation();

	const { data: telks } = useGetProfileAttachmentsQuery(id);

	console.log(telks);

	// 3. Handle user deletion
	const handleDelete = async () => {
		try {
			await deleteUser({ id: +id }).unwrap();
			navigate('/admin/users');
		} catch (error) {
			console.error('Failed to delete user:', error);
		}
	};

	if (isLoading) return <div>Зареждане...</div>;
	if (isError || !user) return <div>Не е намерен потребител</div>;

	let attItems = [];
	if (!telks || telks.length === 0) {
		attItems = <span>Няма прикачени файлове.</span>;
	} else {
		attItems = telks.map((telk, index) => (
			<React.Fragment key={telk.id}>
				{index > 0 ? ' ' : null}
				<NavLink to={telk.file_name} target="_blank" rel="noopener">
					{telk.name}
				</NavLink>
			</React.Fragment>
		));
	}
	return (
		<Container maxWidth="md" className={classes.container}>
			<Paper className={classes.paper}>
				<Typography variant="h4" gutterBottom>
					Детайли
				</Typography>

				{/* Buttons for edit (Корекция) and delete (Изтрий) */}
				<div className={classes.buttons}>
					<Button
						variant="contained"
						color="primary"
						onClick={() => navigate(`/admin/users/edit/${id}`)}
					>
						Корекция
					</Button>
					<Button variant="contained" color="secondary" onClick={handleDelete}>
						Изтрий
					</Button>
				</div>

				{/* Display user information */}
				<div className={classes.row}>
					<span className={classes.label}>Потребител:</span>
					<span>{user.username}</span>
				</div>
				<div className={classes.row}>
					<span className={classes.label}>Първо име:</span>
					<span>{user.first_name}</span>
				</div>
				<div className={classes.row}>
					<span className={classes.label}>Последно име:</span>
					<span>{user.last_name}</span>
				</div>
				<div className={classes.row}>
					<span className={classes.label}>Имейл:</span>
					<span>{user.email}</span>
				</div>
				<div className={classes.row}>
					<span className={classes.label}>Администратор:</span>
					<span>{user.is_superuser ? 'Да' : 'Не'}</span>
				</div>
				<div className={classes.row}>
					<span className={classes.label}>Служител в РСО:</span>
					<span>{user.is_staff ? 'Да' : 'Не'}</span>
				</div>
				{/* If your user model has an “active” field or similar */}
				{/* <div className={classes.row}>
          <span className={classes.label}>Активен:</span>
          <span>{user.is_active ? 'Да' : 'Не'}</span>
        </div> */}
				<div className={classes.row}>
					<span className={classes.label}>ЕГН:</span>
					<span>{user.tbl_profile?.code}</span>
				</div>
				<div className={classes.row}>
					<span className={classes.label}>Адрес:</span>
					<span>{user.tbl_profile?.id_card}</span>
				</div>
				<div className={classes.row}>
					<span className={classes.label}>Организация:</span>
					<span>
						{Const.ORGANIZATIONS[user.tbl_profile?.organization_id] ||
							'Не членува'}
					</span>
				</div>
				<div className={classes.row}>
					<span className={classes.label}>Загубено зрение (%):</span>
					<span>{user.tbl_profile?.lost_vision}</span>
				</div>
				<div className={classes.row}>
					<span className={classes.label}>Статус:</span>
					<span>{user.tbl_profile?.status}</span>
				</div>
				{/* If you store “ТЕЛК решение” in a separate field or attachments, display it here */}
				<div className={classes.row}>
					<span className={classes.label}>ТЕЛК решение:</span>
					{attItems}
				</div>
				<div className={classes.row}>
					<span className={classes.label}>Регистриран на:</span>
					<span>{user.date_joined}</span>
				</div>
				<div className={classes.row}>
					<span className={classes.label}>Последно видян на:</span>
					<span>{user.last_login}</span>
				</div>
			</Paper>
		</Container>
	);
}
